export const shouldSocialsModalShow = () => {
  return sessionStorage.getItem("showSocialsOnRedirect") === "true";
};

export const setSocialsModalShowKey = () => {
  sessionStorage.setItem("showSocialsOnRedirect", "true");
};

export const removeSocialsModalShowKey = () => {
  sessionStorage.removeItem("showSocialsOnRedirect");
};
